import { render, staticRenderFns } from "./WxLoginModel.vue?vue&type=template&id=6715bd14&scoped=true"
import script from "./WxLoginModel.vue?vue&type=script&lang=js"
export * from "./WxLoginModel.vue?vue&type=script&lang=js"
import style0 from "./WxLoginModel.vue?vue&type=style&index=0&id=6715bd14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6715bd14",
  null
  
)

export default component.exports